module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {	
	fox.registerWidget('Catalog3X', {
		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				template: 'catalog_home',
				container: '.models-sitepage-wrapper',
				'!visual': true,
				'widgets.events.widgets.eventsList.widgets.list.manualRender': true
			});

			this.callParent('configure', arguments);
		}

	}, 'Site_Page');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/catalog/catalog3x/catalog3x.js
// module id = 117
// module chunks = 0